import { cn } from "@omni/utils/styles";

import { RouterModal } from "@/components/General/Modal/routerModal";
import { Fiche } from "@/components/Product/energyLabel/components/fiche";
import { Label } from "@/components/Product/energyLabel/components/label";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    discriminator?: string;
    className?: string;
};

export const EnergyLabelModal = ({ discriminator, className }: Props) => {
    const { t } = useGranite();

    return (
        <RouterModal
            className={cn(className)}
            modalType={ModalType.EnergyLabel}
            discriminator={discriminator}
            withFooter={false}
            size={"lg"}
            title={t("modal.energy-label.title")}
        >
            <Fiche className={cn("tw:pl-0")} />
            <Label />
        </RouterModal>
    );
};
